import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <div className="container mt-3">
      <div className="row">
      <div className="col-md-6">
      <div className="row no-gutters">
      <div className="col-md-3">
  <Link to="/" className="text-color">  <h1 >Front-end<br /><h4 className="">Development</h4></h1></Link>
        </div>
        <div className="col-md-3">
        <h5 className="mt-2  ml-2 pl-1 text-color font-weight-bold mb-3 mb-md-0">
          Software
          Development
           Service
        </h5>
        </div>

        </div>
</div>
        <div class="col-md-6">
          <div className="row no-gutters">
            <div className="text-right margin">
            <p className="font-weight-bold text-left">
             EVERYTHING <span className="text-color">YOU</span> <br />
              CAN <span className="text-color">IMAGINE</span>
              <br />
              IS<span className="text-color ml-2">REAL</span>
          
          </p>
</div>


            </div>
     
</div>
   
          </div>
</div>
    </>
  );
};

export default Navbar;
